import type { ReactElement } from 'react'

interface DossLogomarkProps {
  className?: string | undefined
}

/**
 * Doss logomark — the two offset squares, without the wordmark. Fills with `currentColor` so it
 * takes the surrounding text color. Size comes from CSS, not props.
 */
export const DossLogomark = ({ className }: DossLogomarkProps): ReactElement => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M0 0.50992C0 0.228299 0.227691 0 0.508562 0H45.3688C45.6497 0 45.8775 0.228299 45.8775 0.50992V18.4H18.351V46H0.508562C0.227691 46 0 45.7716 0 45.49V0.50992Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M64 63.49C64 63.7716 63.7722 64 63.4913 64H18.6311C18.3502 64 18.1225 63.7716 18.1225 63.49V45.6H45.6491V18H63.4913C63.7722 18 64 18.2283 64 18.5099V63.49Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
